import { ShortcutBinding } from '../../../proxy/models/shortcut-binding';

export enum ShortcutTarget {
  Dashboard = 'dashboard',
  OpenRequests = 'openRequests',
  NewRequest = 'newRequest',
  Notifications = 'notifications',
  MyBoards = 'myBoards',
  SharedBoards = 'sharedBoards',
  TrendsInsights = 'trendsInsights',
  InsightsMatrix = 'insightsMatrix',
  MyDetails = 'myDetails',
  Help = 'help',
  Navigation = 'Navigation',
}

export const PAGE_SHORTCUTS: Record<ShortcutTarget, ShortcutBinding> = {
  [ShortcutTarget.Dashboard]: {
    id: 'dashboard',
    key: 'u',
    description: '',
    action: 'navigate',
    target: '/dashboard'
  },
  [ShortcutTarget.NewRequest]: {
    id: 'newRequest',
    key: 'r',
    description: '',
    action: 'navigate',
    target: '/request/new'
  },
  [ShortcutTarget.OpenRequests]: {
    id: 'open-requests',
    key: 'o',
    description: '',
    action: 'navigate',
    target: '/requests/pending'
  },
  [ShortcutTarget.Notifications]: {
    id: 'notifications',
    key: 'f',
    description: '',
    action: 'navigate',
    target: '/notifications'
  },
  [ShortcutTarget.MyBoards]: {
    id: ShortcutTarget.MyBoards,
    key: 'm',
    description: '',
    action: 'navigate',
    target: '/boards?type=my'
  },
  [ShortcutTarget.SharedBoards]: {
    id: ShortcutTarget.SharedBoards,
    key: 'b',
    description: '',
    action: 'navigate',
    target: '/boards?type=shared'
  },
  [ShortcutTarget.TrendsInsights]: {
    id: 'trends-insights',
    key: 'e',
    description: '',
    action: 'navigate',
    target: '/trends-insights'
  },
  [ShortcutTarget.InsightsMatrix]: {
    id: 'insights-matrix',
    key: 'i',
    description: '',
    action: 'navigate',
    target: '/insights-matrix/dashboards'
  },
  [ShortcutTarget.MyDetails]: {
    id: ShortcutTarget.MyDetails,
    key: 'd',
    description: '',
    action: 'custom',
    target: ''
  },
  [ShortcutTarget.Help]: {
    id: ShortcutTarget.Help,
    key: 'h',
    description: '',
    action: 'custom',
    target: ''
  },
  [ShortcutTarget.Navigation]: {
    id: ShortcutTarget.Navigation,
    key: 'a',
    description: '',
    action: 'custom',
    target: ''
  },
};

export function getShortcutTarget(shortcutTarget: ShortcutTarget): string {
  const isMac = navigator?.platform?.toUpperCase().includes('MAC');

  return (isMac ? '⌘' : 'Ctrl') + ' K → ' + PAGE_SHORTCUTS[shortcutTarget].key.toUpperCase();
}

export function getShortcutKey(shortcutTarget: ShortcutTarget): string {
  return PAGE_SHORTCUTS[shortcutTarget].key.toUpperCase();
}

export function getShortcutPrefix(): string {
  const isMac = navigator?.platform?.toUpperCase().includes('MAC');

  return (isMac ? '⌘' : 'Ctrl') + ' K';
}

const SHORTCUT_LABELS: Partial<Record<ShortcutTarget, string>> = {
  [ShortcutTarget.Navigation]: 'Menu',
  [ShortcutTarget.NewRequest]: 'New request',
  [ShortcutTarget.OpenRequests]: 'Open requests',
  [ShortcutTarget.MyBoards]: 'My boards',
  [ShortcutTarget.SharedBoards]: 'Shared boards',
  [ShortcutTarget.TrendsInsights]: 'Trends & insights',
  [ShortcutTarget.InsightsMatrix]: 'Insights matrix',
  [ShortcutTarget.Notifications]: 'Notifications',
  [ShortcutTarget.MyDetails]: 'Sign-in & security',
  [ShortcutTarget.Help]: 'Help',
  [ShortcutTarget.Dashboard]: 'Dashboard',
};

export function getShortcutList(): { key: string; label: string }[] {
  return (Object.keys(SHORTCUT_LABELS) as ShortcutTarget[])
    .filter(target => PAGE_SHORTCUTS[target])
    .map(target => ({
      key: PAGE_SHORTCUTS[target].key.toUpperCase(),
      label: SHORTCUT_LABELS[target] as string,
    }));
}
